import { Chart } from "react-google-charts";
import React, {useState, useEffect, useRef} from 'react';
import BarraNavegacao from "../components/BarraNavegacao";
import LogoWebSai from '../assets/logo.png';
import { MdSearch } from "react-icons/md";
import { BiBarChartAlt2,BiDownload,BiSearch } from "react-icons/bi";
import Select from 'react-select';
import axios from 'axios';
import Swal from 'sweetalert2'
import { RotatingLines } from 'react-loader-spinner';
import Accordion from 'react-bootstrap/Accordion';
import Modal from 'react-bootstrap/Modal';
import Nav from 'react-bootstrap/Nav';
const ExcelJS = require('exceljs');

export default function Tabulacao(){


    const [loaPesquia, setLoadPesquisa] = useState(false);
    const [loadTipoUnidades, setLoadTipoUnidades] = useState(false);
    const [loadUnidades, setLoadUnidades] = useState(false);
    const [loadGrafico, setLoadGrafico] = useState(false);
    const [pesquisas, setPesquisas] = useState([]);
    const [tipounidades, setTipoUnidades] = useState([]);
    const [tiporelatorio, setTipoRelatorio] = useState([]);
    const [aviso, setAviso] = useState("d-none");
    const [loadingTiposRelatorio, setLoadTiposRelatorio] = useState(false);
    const [unidades, setUnidades] = useState([]);
    const [graficos, setGraficos] = useState([]);
    const [dados, setDados] = useState([]);
    const [questoesSearch, setQuestoesSearch] = useState([]);
    const [error, setErrors] = useState({});
    const [inputs, setInputs] = useState({});
    const [selectedOption, setSelectedOption] = useState(null);
    const selectRef = useRef(null);
    const [modalTabulacao, setModalTabulacao] = useState(false);
    const [titleModal, setTitleModal] = useState("");
    const [tipoGrafico, setTipoGrafico] = useState("funcionario");

    useEffect(()=>{
        consultarPesquisas();
        consultarTipoUnidades();
    }, []);

    const handledChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values,[name]:value}));
    }

    const consultarPesquisas = () =>
    {
        setLoadPesquisa(true);
        axios.get(process.env.REACT_APP_API + 'edicoes', {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status === 200 && response.data.statusCode === 200) {
                setPesquisas(response.data.value);
            } else window.location.href = process.env.REACT_APP_HOST;
            setLoadPesquisa(false);
        }).catch((error) => {
            sessionStorage.clear();
             window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const consultarTipoUnidades = () =>
    {
        setLoadTipoUnidades(true);
        axios.get(process.env.REACT_APP_API + 'TipoUnidades', {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status === 200 && response.data.statusCode === 200) {
                setTipoUnidades(response.data.value);
            } else window.location.href = process.env.REACT_APP_HOST;
            setLoadTipoUnidades(false);
        }).catch((error) => {
            sessionStorage.clear();
             window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const consultarUnidades = (event) =>
    {
        setUnidades([]);
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values,[name]:value}));
        
        if(event.target.value !== "") {
            setLoadUnidades(true);
            axios.get(process.env.REACT_APP_API + 'Unidades/Tipos/'+event.target.value, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
            .then(function(response) {
                if(response.status !== 200) {
                    sessionStorage.clear();
                    window.location.href = process.env.REACT_APP_HOST+"login";
                    return;
                }

                setLoadUnidades(false);
                setUnidades([]);
                if(response.data.statusCode === 400) {
                    Swal.fire({
                        title: 'Não foi possível buscar os dados',
                        text: response.data.value.message,
                        icon: 'warning',
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText:'Fechar'
                    })
                    return;
                }
                else {
                    response.data.value.forEach((item) => {
                        setUnidades(unidades => [...unidades,{label:item.nomeSimplicado, value:item.unidadeId}]);
                    })
                }
            }).catch((error) => {
                sessionStorage.clear();
                 window.location.href = process.env.REACT_APP_HOST+"login";
            })
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        gerarAcompanhamento();
    }

    const gerarAcompanhamento = () => {
        if(!inputs.idpesquisa) setErrors(values => ({...values,pesquisa:"Selecione a edição"})); else setErrors(values => ({...values,pesquisa:""})); 
        if(!inputs.idtipounidade) setErrors(values => ({...values,tipounidade:"Selecione o tipo de unidade"})); else setErrors(values => ({...values,tipounidade:""})); 
        if(!selectedOption) setErrors(values => ({...values,unidade:"Selecione a unidade"})); else setErrors(values => ({...values,unidade:""})); 
        if(inputs.idpesquisa && selectedOption && inputs.idtipounidade)
        {
            setTipoRelatorio([]);
            setLoadTiposRelatorio(true);

            axios.get(process.env.REACT_APP_API + 'Relatorios/Distinct/FormularioApelidos/Edicoes/'+inputs.idpesquisa+'/TipoUnidades/'+inputs.idtipounidade, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
            .then(function(response) {

                if(response.status !== 200) {
                    sessionStorage.clear();
                    window.location.href = process.env.REACT_APP_HOST+"login";
                    return;
                }

                if(response.data.statusCode === 200) {
                    setAviso("d-none");
                    setTipoRelatorio(response.data.value.data);
                }
                else {
                    setAviso("");
                    setTipoRelatorio([]);
                }
                setLoadTiposRelatorio(false);
            }).catch((error) => {
                sessionStorage.clear();
                 window.location.href = process.env.REACT_APP_HOST+"login";
            })
        }
    }

    const controlModalTabulacao = (state,descricao,idgrupo,idformularioapelido) => {
        setModalTabulacao(state);
        if(state) 
        {
            let txtGenero = inputs.genero !== "todos" && typeof inputs.genero !== "undefined" ? " (" + inputs.genero + ")" : "";
            setTitleModal(descricao + txtGenero);
            setGraficos([]);
            setQuestoesSearch([])
            setDados([]);
            setLoadGrafico(true);
            if (idformularioapelido === "997e3951-0d07-4ee4-86bd-296970c9af6e" || idformularioapelido === "d6abf267-9b9a-487b-95d9-61cf5c86b84a" || idformularioapelido === "673c46d0-10c8-42d8-b0ac-a64111fad5da" || idformularioapelido === "fde7e6a0-9155-4e52-a16b-d9c7f7598523") //alunos ou egressos
            {
                
                if(inputs.genero === "todos" || typeof inputs.genero === "undefined") {
                    setTipoGrafico("aluno");
                    axios.get(process.env.REACT_APP_API + 'Relatorios/Tabulacao/Discentes/UnidadesCursos/Edicao/'+inputs.idpesquisa+'/Formulario/'+idgrupo+'/unidade/'+selectedOption.value, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
                    .then(function(response) {
                        if(response.status !== 200) {
                            sessionStorage.clear();
                            window.location.href = process.env.REACT_APP_HOST+"login";
                            return;
                        }

                        if(response.data.statusCode === 400){ setLoadGrafico(false); return; }
                        var vetFormulario = [];
                        response.data.value[0].tipoUnidades[0].unidades[0].formularios[0].cursos.forEach((curso, indexCursos) => {
                            //var formulario = new Object();
                            var formulario = {};
                            formulario.curso = curso.curso;
                            formulario.questao = [];
                            curso.indicadores.forEach((indicador) => {
                                indicador.dimensoes.forEach((dimensao) => {
                                    dimensao.areas.forEach((areas) => {
                                        areas.questoes.forEach((questoes,indexQuestoes) => {
                                            //var questao = new Object();
                                            var questao = {};
                                            questao.numero = questoes.numeroPergunta;
                                            questao.descricao = questoes.questao;
                                            var vetAlternativas = questoes.respostas.split(',');
                                            var alternativas = [["Descrição","Total"]];

                                            vetAlternativas.forEach((alt,indexAlt) => {
                                                var percentual = 0;
                                                if(indexAlt === 0) percentual = questoes.totalA;
                                                if(indexAlt === 1) percentual = questoes.totalB;
                                                if(indexAlt === 2) percentual = questoes.totalC;
                                                if(indexAlt === 3) percentual = questoes.totalD;
                                                if(indexAlt === 4) percentual = questoes.totalE;
                                                if(indexAlt === 5) percentual = questoes.totalF;
                                                if(indexAlt === 6) percentual = questoes.totalG;
                                                if(indexAlt === 7) percentual = questoes.totalH;
                                                if(indexAlt === 8) percentual = questoes.totalI;
                                                if(indexAlt === 9) percentual = questoes.totalJ;
                                                if(indexAlt === 10) percentual = questoes.totalK;
                                                if(indexAlt === 11) percentual = questoes.totalL;
                                                if(indexAlt === 12) percentual = questoes.totalM;
                                                if(indexAlt === 13) percentual = questoes.totalN;
                                                alternativas.push([alt,percentual])
                                            })

                                            questao.alternativas = alternativas;
                                            formulario.questao.push(questao);
                                        }) 
                                    })
                                })
                            })
                            formulario.questao.sort((a, b) => a.numero - b.numero);
                            vetFormulario[indexCursos] = formulario;
                        })
                        setGraficos(vetFormulario);
                        setQuestoesSearch(vetFormulario);
                        setDados(response.data.value);
                        setLoadGrafico(false);

                    }).catch((error) => {
                        sessionStorage.clear();
                        window.location.href = process.env.REACT_APP_HOST+"login";
                    })
                }
                else {
                    setTipoGrafico("genero");
                    discentesPorFaixaGenero(idgrupo);
                }
            }
            else //funcionários
            {
                if(inputs.genero === "todos" || typeof inputs.genero === "undefined") {
                    setTipoGrafico("funcionario");
                    axios.get(process.env.REACT_APP_API + 'Relatorios/Tabulacao/Funcionarios/Unidades/Edicao/'+inputs.idpesquisa+'/Formulario/'+idgrupo+'/Unidade/'+selectedOption.value, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
                    .then(function(response) {
                        if(response.status !== 200) {
                            sessionStorage.clear();
                            window.location.href = process.env.REACT_APP_HOST+"login";
                            return;
                        }

                        if(response.data.statusCode === 400){ setLoadGrafico(false); return; }
                        var vetQuestao = [];
                        var cont = 0;
                        response.data.value[0].tipoUnidades[0].unidades[0].formularios[0].indicadores.forEach((indicador) => {
                            indicador.dimensoes.forEach((dimensao) => {
                                dimensao.areas.forEach((areas) => { 
                                    areas.questoes.forEach((questoes) => {
                                        //var questao = new Object();
                                        var questao = {};
                                        questao.numero = questoes.numeroPergunta;
                                        questao.descricao = questoes.questao;
                                        var vetAlternativas = questoes.respostas.split(',');
                                        var alternativas = [["Descrição","Total"]];

                                        
                                        vetAlternativas.forEach((alt,indexAlt) => {
                                            var percentual = 0;
                                            if(indexAlt === 0) percentual = questoes.totalA;
                                            if(indexAlt === 1) percentual = questoes.totalB;
                                            if(indexAlt === 2) percentual = questoes.totalC;
                                            if(indexAlt === 3) percentual = questoes.totalD;
                                            if(indexAlt === 4) percentual = questoes.totalE;
                                            if(indexAlt === 5) percentual = questoes.totalF;
                                            if(indexAlt === 6) percentual = questoes.totalG;
                                            if(indexAlt === 7) percentual = questoes.totalH;
                                            if(indexAlt === 8) percentual = questoes.totalI;
                                            if(indexAlt === 9) percentual = questoes.totalJ;
                                            if(indexAlt === 10) percentual = questoes.totalK;
                                            if(indexAlt === 11) percentual = questoes.totalL;
                                            if(indexAlt === 12) percentual = questoes.totalM;
                                            if(indexAlt === 13) percentual = questoes.totalN;
                                            alternativas.push([alt,percentual])
                                        })

                                        
                                        questao.alternativas = alternativas;
                                        vetQuestao[cont] = questao;
                                        cont++;
                                    })
                                })
                            })

                            vetQuestao.sort((a, b) => a.numero - b.numero);
                        })
                        setGraficos(vetQuestao);
                        setQuestoesSearch(vetQuestao);
                        setDados(response.data.value);
                        setLoadGrafico(false);
                    }).catch((error) => {
                        sessionStorage.clear();
                        window.location.href = process.env.REACT_APP_HOST+"login";
                    })
                }
                else {
                    setTipoGrafico("genero");
                    funcionariosPorFaixaGenero(idgrupo);
                }
            }
            
        }
    }

    const discentesPorFaixaGenero = (idgrupo) => {
        axios.get(process.env.REACT_APP_API + 'Tabulacoes/Discentes/Genero/Unidades/Edicao/'+inputs.idpesquisa+'/formulario/'+idgrupo+'/unidade/'+selectedOption.value, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {            
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }

            if(response.data.statusCode === 400){ setLoadGrafico(false); return; }
            var vetFormulario = [];
            var vetGeneros = [];
            var vetIndicadores = [];

            if(typeof inputs.genero !== "undefined" && inputs.genero !== "todos") vetGeneros = response.data.value[0].tipoUnidades[0].unidades[0].formularios[0].generos.filter((v) => v.genero === inputs.genero);
            else vetGeneros = response.data.value[0].tipoUnidades[0].unidades[0].formularios[0].generos;            
            vetIndicadores = vetGeneros[0].faixaEtarias;

            vetIndicadores.map((dados,index) => {
                var formulario = {};
                formulario.curso = dados.faixaEtaria;
                formulario.questao = [];

                dados.indicadores.forEach((indicador) => {
                    indicador.dimensoes.forEach((dimensao) => {
                        dimensao.areas.forEach((areas) => {
                            areas.questoes.forEach((questoes,indexQuestoes) => {
                                var questao = {};
                                questao.numero = questoes.numeroPergunta;
                                questao.descricao = questoes.questao;
                                var vetAlternativas = questoes.respostas.split(',');
                                var alternativas = [["Descrição","Total"]];

                                vetAlternativas.forEach((alt,indexAlt) => {
                                    var percentual = 0;
                                    if(indexAlt === 0) percentual = questoes.totalA;
                                    if(indexAlt === 1) percentual = questoes.totalB;
                                    if(indexAlt === 2) percentual = questoes.totalC;
                                    if(indexAlt === 3) percentual = questoes.totalD;
                                    if(indexAlt === 4) percentual = questoes.totalE;
                                    if(indexAlt === 5) percentual = questoes.totalF;
                                    if(indexAlt === 6) percentual = questoes.totalG;
                                    if(indexAlt === 7) percentual = questoes.totalH;
                                    if(indexAlt === 8) percentual = questoes.totalI;
                                    if(indexAlt === 9) percentual = questoes.totalJ;
                                    if(indexAlt === 10) percentual = questoes.totalK;
                                    if(indexAlt === 11) percentual = questoes.totalL;
                                    if(indexAlt === 12) percentual = questoes.totalM;
                                    if(indexAlt === 13) percentual = questoes.totalN;
                                    alternativas.push([alt,percentual])
                                })

                                questao.alternativas = alternativas;
                                formulario.questao.push(questao);
                            }) 
                        })
                    })
                });
                
                formulario.questao.sort((a, b) => a.numero - b.numero);
                vetFormulario[index] = formulario;
            });

            setGraficos(vetFormulario);
            setQuestoesSearch(vetFormulario);
            setDados(response.data.value);
            setLoadGrafico(false);
            
        }).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        })
    } 

    const funcionariosPorFaixaGenero = (idgrupo) => {
        axios.get(process.env.REACT_APP_API + 'Tabulacoes/Funcionarios/Genero/Unidades/Edicao/'+inputs.idpesquisa+'/formulario/'+idgrupo+'/unidade/'+selectedOption.value, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {            
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }

            if(response.data.statusCode === 400){ setLoadGrafico(false); return; }
            var vetFormulario = [];
            var vetGeneros = [];
            var vetIndicadores = [];

            if(typeof inputs.genero !== "undefined" && inputs.genero !== "todos") vetGeneros = response.data.value[0].tipoUnidades[0].unidades[0].formularios[0].generos.filter((v) => v.genero === inputs.genero);
            else vetGeneros = response.data.value[0].tipoUnidades[0].unidades[0].formularios[0].generos;            
            vetIndicadores = vetGeneros[0].faixaEtarias;

            vetIndicadores.map((dados,index) => {
                var formulario = {};
                formulario.curso = dados.faixaEtaria;
                formulario.questao = [];

                dados.indicadores.forEach((indicador) => {
                    indicador.dimensoes.forEach((dimensao) => {
                        dimensao.areas.forEach((areas) => {
                            areas.questoes.forEach((questoes,indexQuestoes) => {
                                var questao = {};
                                questao.numero = questoes.numeroPergunta;
                                questao.descricao = questoes.questao;
                                var vetAlternativas = questoes.respostas.split(',');
                                var alternativas = [["Descrição","Total"]];

                                vetAlternativas.forEach((alt,indexAlt) => {
                                    var percentual = 0;
                                    if(indexAlt === 0) percentual = questoes.totalA;
                                    if(indexAlt === 1) percentual = questoes.totalB;
                                    if(indexAlt === 2) percentual = questoes.totalC;
                                    if(indexAlt === 3) percentual = questoes.totalD;
                                    if(indexAlt === 4) percentual = questoes.totalE;
                                    if(indexAlt === 5) percentual = questoes.totalF;
                                    if(indexAlt === 6) percentual = questoes.totalG;
                                    if(indexAlt === 7) percentual = questoes.totalH;
                                    if(indexAlt === 8) percentual = questoes.totalI;
                                    if(indexAlt === 9) percentual = questoes.totalJ;
                                    if(indexAlt === 10) percentual = questoes.totalK;
                                    if(indexAlt === 11) percentual = questoes.totalL;
                                    if(indexAlt === 12) percentual = questoes.totalM;
                                    if(indexAlt === 13) percentual = questoes.totalN;
                                    alternativas.push([alt,percentual])
                                })

                                questao.alternativas = alternativas;
                                formulario.questao.push(questao);
                            }) 
                        })
                    })
                });
                
                formulario.questao.sort((a, b) => a.numero - b.numero);
                vetFormulario[index] = formulario;
            });

            setGraficos(vetFormulario);
            setQuestoesSearch(vetFormulario);
            setDados(response.data.value);
            setLoadGrafico(false);
            
        }).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        })
    } 

    const searchQuestao = (event) => {
        var updatedList = [...graficos];
        if(tipoGrafico === "funcionario"){
            const filtered = updatedList.filter(item => {
                return item.descricao.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1
            });
            setQuestoesSearch(filtered);
        }
        else {
            const filtered = updatedList.filter(item => {
                return item.curso.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1
            });
            setQuestoesSearch(filtered);
        }
    }

    const exportExcel = () => {
        const workbook = new ExcelJS.Workbook();
        workbook.creator = 'WebSai';
        workbook.created = new Date();
        workbook.modified = new Date();
        workbook.lastPrinted = new Date();
        
        const sheet = workbook.addWorksheet(titleModal);
        sheet.columns = [
            { key: 'Indicador'},
            { key: 'Dimensao'},
            { key: 'Area'},
            { key: 'NumeroPergunta'},
            { key: 'Questao'},
            { key: 'Respostas'},
            { key: 'TotalA'},
            { key: 'TotalB'},
            { key: 'TotalC'},
            { key: 'TotalD'},
            { key: 'TotalE'},
            { key: 'TotalF'},
            { key: 'TotalG'},
            { key: 'TotalH'},
            { key: 'TotalI'},
            { key: 'TotalJ'},
            { key: 'TotalK'},
            { key: 'TotalL'},
            { key: 'TotalM'},
            { key: 'TotalN'},
            { key: 'TotalValido'},
            { key: 'PercA'},
            { key: 'PercB'},
            { key: 'PercC'},
            { key: 'PercD'},
            { key: 'PercE'},
            { key: 'PercF'},
            { key: 'PercG'},
            { key: 'PercH'},
            { key: 'PercI'},
            { key: 'PercJ'},
            { key: 'PercK'},
            { key: 'PercL'},
            { key: 'PercM'},
            { key: 'PercN'},
            { key: 'PercValido'},
            { key: 'TotalEsperado'},
            { key: 'PercEsperado'}
        ];

        dados.forEach((item, key) =>
            {
                sheet.addRow({
                    Indicador: item.edicao + ' - ' + item.tipoUnidades[0].unidades[0].unidade + ' ('+ item.tipoUnidades[0].unidades[0].formularios[0].formularioId+')'
                });
                sheet.addRow({
                    Indicador: item.tipoUnidades[0].unidades[0].formularios[0].formularioApelido + ' ('+ item.tipoUnidades[0].unidades[0].formularios[0].formularioId+')'
                });
                sheet.addRow({
                    Indicador : 'Indicador',
                    Dimensao: 'Dimensão',
                    Area: 'Área',
                    NumeroPergunta: 'Número',
                    Questao: 'Questão',
                    Respostas: 'Respostas',
                    TotalA: 'TotalA',
                    TotalB: 'TotalB',
                    TotalC: 'TotalC',
                    TotalD: 'TotalD',
                    TotalE: 'TotalE',
                    TotalF: 'TotalF',
                    TotalG: 'TotalG',
                    TotalH: 'TotalH',
                    TotalI: 'TotalI',
                    TotalJ: 'TotalJ',
                    TotalK: 'TotalK',
                    TotalL: 'TotalL',
                    TotalM: 'TotalM',
                    TotalN: 'TotalN',
                    TotalValido: 'TotalValido',
                    PercA: 'PercA',
                    PercB: 'PercB',
                    PercC: 'PercC',
                    PercD: 'PercD',
                    PercE: 'PercE',
                    PercF: 'PercF',
                    PercG: 'PercG',
                    PercH: 'PercH',
                    PercI: 'PercI',
                    PercJ: 'PercJ',
                    PercK: 'PercK',
                    PercL: 'PercL',
                    PercM: 'PercM',
                    PercN: 'PercN',
                    PercValido: 'PercValido',
                    TotalEsperado: 'TotalEsperado',
                    PercEsperado: 'PercEsperado'
                });

                if(tipoGrafico === 'funcionario') { 
                    item.tipoUnidades[0].unidades[0].formularios[0].indicadores.forEach((indicador) => {
                        indicador.dimensoes.forEach((dimensao) => {
                            dimensao.areas.forEach((area) => {
                                area.questoes.forEach((questao) => {
                                    sheet.addRow({
                                        Indicador : indicador.indicador,
                                        Dimensao: dimensao.dimensao,
                                        Area: area.area,
                                        NumeroPergunta: questao.numeroPergunta,
                                        Questao: questao.questao,
                                        Respostas: questao.respostas,
                                        TotalA: questao.totalA,
                                        TotalB: questao.totalB,
                                        TotalC: questao.totalC,
                                        TotalD: questao.totalD,
                                        TotalE: questao.totalE,
                                        TotalF: questao.totalF,
                                        TotalG: questao.totalG,
                                        TotalH: questao.totalH,
                                        TotalI: questao.totalI,
                                        TotalJ: questao.totalJ,
                                        TotalK: questao.totalK,
                                        TotalL: questao.totalL,
                                        TotalM: questao.totalM,
                                        TotalN: questao.totalN,
                                        TotalValido: questao.totalValido,
                                        PercA: questao.percA,
                                        PercB: questao.percB,
                                        PercC: questao.percC,
                                        PercD: questao.percD,
                                        PercE: questao.percE,
                                        PercF: questao.percF,
                                        PercG: questao.percG,
                                        PercH: questao.percH,
                                        PercI: questao.percI,
                                        PercJ: questao.percJ,
                                        PercK: questao.percK,
                                        PercL: questao.percL,
                                        PercM: questao.percM,
                                        PercN: questao.percN,
                                        PercValido: questao.percValido,
                                        TotalEsperado: questao.totalEsperado,
                                        PercEsperado: questao.percEsperado
                                    });
                                })
                            })
                        })
                    })
                }
                else {
                    item.tipoUnidades[0].unidades[0].formularios[0].cursos.forEach((curso) => {
                        sheet.addRow({
                            Indicador: curso.curso + ' ('+curso.cursoId+')'
                        });
                        curso.indicadores.forEach((indicador) => {
                            indicador.dimensoes.forEach((dimensao) => {
                                dimensao.areas.forEach((area) => {
                                    area.questoes.forEach((questao) => {
                                        sheet.addRow({
                                            Indicador : indicador.indicador,
                                            Dimensao: dimensao.dimensao,
                                            Area: area.area,
                                            NumeroPergunta: questao.numeroPergunta,
                                            Questao: questao.questao,
                                            Respostas: questao.respostas,
                                            TotalA: questao.totalA,
                                            TotalB: questao.totalB,
                                            TotalC: questao.totalC,
                                            TotalD: questao.totalD,
                                            TotalE: questao.totalE,
                                            TotalF: questao.totalF,
                                            TotalG: questao.totalG,
                                            TotalH: questao.totalH,
                                            TotalI: questao.totalI,
                                            TotalJ: questao.totalJ,
                                            TotalK: questao.totalK,
                                            TotalL: questao.totalL,
                                            TotalM: questao.totalM,
                                            TotalN: questao.totalN,
                                            TotalValido: questao.totalValido,
                                            PercA: questao.percA,
                                            PercB: questao.percB,
                                            PercC: questao.percC,
                                            PercD: questao.percD,
                                            PercE: questao.percE,
                                            PercF: questao.percF,
                                            PercG: questao.percG,
                                            PercH: questao.percH,
                                            PercI: questao.percI,
                                            PercJ: questao.percJ,
                                            PercK: questao.percK,
                                            PercL: questao.percL,
                                            PercM: questao.percM,
                                            PercN: questao.percN,
                                            PercValido: questao.percValido,
                                            TotalEsperado: questao.totalEsperado,
                                            PercEsperado: questao.percEsperado
                                        });
                                    })
                                })
                            })
                        })
                        sheet.addRow({
                            Indicador: ''
                        });
                    })
                }
            }
        );

        

       workbook.xlsx.writeBuffer().then(data => {
            const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheet.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = 'download.xlsx';
            anchor.click();
            window.URL.revokeObjectURL(url);
        })
    }
    

    return (
        <div> 
            <BarraNavegacao/>
            <div className="container">
                <div className="row mt-2">
                    <div className="col-sm-12">
                        <div className="background rounded p-3">
                            <div className="text-center mb-2">
                                <img src={LogoWebSai} alt="Logo" style={{width:150}}/>
                            </div>
                            <p className="text-center fw-bold fs-5 mb-0">TABULAÇÃO WEBSAI</p>
                            <p className="text-center">Visualize informações e gráficos sobre a coleta de respostas nos questionários, opcionalmente filtrando conforme desejado.</p>
                            <hr/>
                            <div className="bg-white rounded p-3 border mb-2">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="mb-2 col-sm-6">
                                            <label htmlFor="idpesquisa">Selecione a edição</label>
                                            <select className="form-control" name="idpesquisa" onChange={handledChange}>
                                                <option value="">{loaPesquia ? 'Carregando...':'Selecione...'}</option>
                                                {
                                                    typeof pesquisas !== "undefined" ?
                                                    pesquisas.map((pesquisa, key) => 
                                                        <option value={pesquisa.edicaoId}>{pesquisa.descricao} (Aplicação: {pesquisa.anoEdicao} | Egresso: {pesquisa.anoEgresso})</option>
                                                    ):null
                                                }
                                            </select>
                                            <span className="text-danger">{error.pesquisa}</span>
                                        </div>
                                        <div className="mb-2 col-sm-6">
                                            <label htmlFor="idtipounidade">Tipo de Unidade</label>
                                            <select className="form-control" name="idtipounidade" onChange={consultarUnidades}>
                                                <option value={""}>{loadTipoUnidades ? 'Carregando...':'Selecione...'}</option>
                                                {
                                                    tipounidades.map((tipos, key) => 
                                                        <option value={tipos.tipoUnidadeId}>{tipos.descricao}</option>
                                                    )
                                                }
                                            </select>
                                            <span className="text-danger">{error.tipounidade}</span>
                                        </div>
                                        <div className="mb-2 col-sm-9">
                                            <label htmlFor="idunidade">Selecionar unidade</label>
                                            <Select
                                                options={unidades}
                                                onChange={setSelectedOption}
                                                placeholder={loadUnidades ? "Carregando...":"Selecione..."}
                                                ref={selectRef}
                                            />
                                            <span className="text-danger">{error.unidade}</span>
                                        </div>
                                        <div className="mb-2 col-sm-3">
                                            <label htmlFor="genero">Filtrar por gênero</label>
                                            <select className="form-control" name="genero" onChange={handledChange}>
                                                <option value="todos">Todos</option>
                                                <option>Masculino</option>
                                                <option>Feminino</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="d-grid gap-2 col-sm-4 mx-auto">
                                        <button type="submit" className="btn btn-custom mt-2">
                                        <MdSearch/> {loadingTiposRelatorio ? "Carregando... " : "Pesquisar "}
                                            <RotatingLines
                                                strokeColor="white"
                                                strokeWidth="5"
                                                animationDuration="0.75"
                                                width="20"
                                                visible={loadingTiposRelatorio}
                                            />
                                        </button>
                                    </div>
                                </form>  
                            </div>

                            <div className="row">
                                <div className={"col-sm-12 "+aviso}>
                                    <div className="alert alert-warning">Não foram localizados registros</div>
                                </div>
                                {   
                                    typeof tiporelatorio !== "undefined" ?
                                    tiporelatorio.map((tipo, key) => 
                                        <div className="col-md-4">
                                            <Nav.Link onClick={() => controlModalTabulacao(true, tipo.titulo, tipo.formularioId, tipo.formularioApelido.formularioApelidoId)}>
                                            <div className="card p-3 mb-2 btn btn-light">
                                                <div className="d-flex justify-content-between">
                                                    <div className="d-flex flex-row align-items-center">
                                                        <div className="icon"> <BiBarChartAlt2 size={50} className="text-danger"/> </div>
                                                        <div className="ms-2 c-details">
                                                            <h5 className="mb-0">{tipo.formularioApelido.descricao}</h5> 
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            </Nav.Link>
                                        </div>
                                    ):null 
                                }
                            </div>
                            

                            <hr/>
                            <div className="text-center mt-3">
                                <svg viewBox="0 0 1000 656.5" style={{width:70}}>
                                    <title>Centro Paula Souza</title>
                                    <path fill="#af0916" d="M760 181.2c.8-23.8 11.1-33.3 45.2-33.3H993V81.4H817c-83.2 0-130 35.6-130 103 0 131.5 240.1 104.6 240.1 174.3 0 23.8-12.7 36.5-45.2 36.5H636.3c24.8-30.3 40-69.4 40-114.1 0-112.5-72.9-207.5-196.4-207.5-111.7 0-191.7 84-191.7 209.1v31.1h-84.6c-65.7 0-130.7-42.8-130.7-123.6s65-123.6 130.7-123.6h53.9V0H191C102.2 0 0 68.1 0 190.1s102.2 190.1 190.9 190.1h97.3v276.2h69.7V380.2h132.7v-66.5H357.9v-18.4c0-104.6 55.5-155.3 122-155.3 74.5 0 126.7 54.6 126.7 132.3 0 66.7-36.1 110-93.3 122.8h-88.9v66.5H882c67.3 0 118-34.1 118-106.1 0-136.3-240.9-108.5-240-174.3" className="icon"></path>
                                    <path d="M481.6 560.8c-3.7 1.7-11.2 3.3-20.8 3.3-22.2 0-38.9-12.5-38.9-35.6 0-22 16.7-37 41.1-37 9.8 0 16 1.9 18.7 3.1l-2.4 7.4c-3.9-1.7-9.4-2.9-15.9-2.9-18.4 0-30.7 10.5-30.7 29 0 17.2 11.1 28.3 30.2 28.3 6.2 0 12.5-1.1 16.6-2.9l2.1 7.3zm16.8-21.2c.2 12.4 9.1 17.5 19.4 17.5 7.4 0 11.8-1.2 15.6-2.6l1.8 6.5c-3.6 1.5-9.8 3.1-18.8 3.1-17.4 0-27.8-10.2-27.8-25.5 0-15.2 10-27.2 26.5-27.2 18.4 0 23.3 14.5 23.3 23.8 0 1.9-.2 3.3-.4 4.3h-39.6zm30.1-6.6c.1-5.8-2.7-14.9-14.2-14.9-10.4 0-14.9 8.5-15.8 14.9h30zm22.6-6.7c0-5.2-.1-9.5-.5-13.7h9.1l.6 8.3h.2c2.8-4.8 9.3-9.5 18.7-9.5 7.8 0 20 4.2 20 21.5v30.2H589V534c0-8.1-3.4-14.9-13.1-14.9-6.8 0-12 4.3-13.8 9.4-.4 1.1-.7 2.7-.7 4.3v30.4h-10.3v-36.9zm76.8-28.2v14.5h14.7v7h-14.7v27.3c0 6.2 2 9.8 7.7 9.8 2.7 0 4.7-.3 6-.6l.5 6.9c-2 .7-5.1 1.3-9.1 1.3-4.8 0-8.6-1.4-11.1-3.9-2.9-2.7-4-7.2-4-13.1v-27.6h-8.8v-7h8.8v-12.1l10-2.5zm26.2 30.3c0-6-.1-11-.5-15.8h9l.3 9.9h.5c2.6-6.8 8.7-11.1 15.6-11.1 1.2 0 2 .1 2.9.3v8.6c-1-.2-2.1-.3-3.5-.3-7.2 0-12.4 4.9-13.8 11.8-.2 1.3-.5 2.7-.5 4.3V563h-10.2v-34.6zm88.2 9.1c0 18.7-14.5 26.8-28.1 26.8-15.3 0-27.1-10-27.1-26 0-16.9 12.4-26.8 28-26.8 16.2 0 27.2 10.5 27.2 26m-44.8.5c0 11.1 7.1 19.4 17.1 19.4 9.8 0 17.2-8.2 17.2-19.6 0-8.6-4.8-19.4-16.9-19.4-12.2 0-17.4 10-17.4 19.6m-270.9 47.3c4.9-.7 11.3-1.4 19.5-1.4 10 0 17.4 2.1 22.1 5.9 4.3 3.3 6.9 8.5 6.9 14.7 0 6.4-2.1 11.4-6.1 15-5.4 5.1-14.1 7.7-24 7.7-3 0-5.9-.1-8.2-.6v28.2h-10.2v-69.5zm10.1 33.9c2.2.5 5 .7 8.4.7 12.3 0 19.7-5.3 19.7-15 0-9.3-7.4-13.8-18.6-13.8-4.4 0-7.8.3-9.6.7v27.4zm79.9 35.6l-.8-6.4h-.3c-3.1 4-9.2 7.5-17.3 7.5-11.4 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.4-6.1c4.7-2.7 11.5-4.5 18.5-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.3zm-1.5-25.8c-11.2-.2-23.9 1.6-23.9 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.4-1 .6-2 .6-2.9V629zm73.8 12c0 5.2.1 9.8.4 13.8h-9.1l-.6-8.2h-.2c-2.7 4.1-8.6 9.4-18.7 9.4-8.9 0-19.5-4.4-19.5-22.1v-29.5h10.3v28c0 9.6 3.3 16.1 12.6 16.1 6.9 0 11.7-4.3 13.5-8.3.6-1.4.9-3 .9-4.7v-31h10.3V641zm17-60.3h10.3v74.1h-10.3zm58.9 74.1l-.8-6.4h-.4c-3.1 4-9.2 7.5-17.3 7.5-11.4 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.3-6.1c4.7-2.7 11.4-4.5 18.6-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.4zm-1.5-25.8c-11.2-.2-24 1.6-24 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.3-1 .6-2 .6-2.9V629zm50.2 14.7c4.5 2.5 11.2 4.6 18.2 4.6 10.4 0 16.5-4.9 16.5-12 0-6.6-4.2-10.3-14.8-14-12.9-4.1-20.8-10-20.8-19.9 0-11 10.1-19.1 25.4-19.1 8 0 13.9 1.7 17.4 3.4l-2.8 7.4c-2.6-1.2-7.8-3.3-15-3.3-10.7 0-14.8 5.7-14.8 10.5 0 6.6 4.8 9.8 15.7 13.6 13.3 4.6 20.1 10.3 20.1 20.7 0 10.9-9 20.2-27.6 20.2-7.6 0-15.9-2-20.1-4.5l2.6-7.6zm110.4-14.6c0 18.7-14.5 26.8-28.1 26.8-15.3 0-27.1-10-27.1-26 0-16.9 12.4-26.8 28-26.8 16.2 0 27.2 10.6 27.2 26m-44.8.5c0 11.1 7.1 19.4 17.2 19.4 9.8 0 17.2-8.3 17.2-19.6 0-8.5-4.8-19.4-16.9-19.4-12.3 0-17.5 10-17.5 19.6m105 11.4c0 5.2.1 9.8.5 13.8h-9.1l-.6-8.2h-.2c-2.7 4.1-8.6 9.4-18.7 9.4-8.9 0-19.5-4.4-19.5-22.1v-29.5h10.3v28c0 9.6 3.3 16.1 12.6 16.1 6.9 0 11.7-4.3 13.5-8.3.6-1.4.9-3 .9-4.7v-31h10.3V641zm10.7 8.5l25.6-29.8c2.4-2.7 4.8-5.1 7.3-7.8v-.2h-30.6v-7.4h43.1l-.1 5.8-25.2 29.3c-2.3 2.8-4.6 5.3-7.2 7.9v.2h33v7.3h-45.9v-5.3zm87.6 5.3l-.8-6.4h-.4c-3.1 4-9.2 7.5-17.3 7.5-11.5 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.3-6.1c4.7-2.7 11.4-4.5 18.6-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.4zm-1.5-25.8c-11.2-.2-23.9 1.6-23.9 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.4-1 .6-2 .6-2.9V629z" className="title"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal size="xl" show={modalTabulacao} onHide={() => controlModalTabulacao(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{titleModal}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    
                    <div className="alert alert-success">
                        <div className="row">
                            <div className="col-sm-12 mb-3">
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping"><BiSearch /></span>
                                    <input type="text" className="form-control" placeholder={tipoGrafico === "funcionario" ? "Filtra por questão..." : tipoGrafico === "genero" ? "Filtrar por faixa etária...": "Filtrar por curso..."} onChange={searchQuestao}/>
                                </div>
                            </div>
                            <div className="col-sm-8">
                                Para informações detalhadas faça o download do arquivo em Excel.
                            </div>
                            <div className="col-sm-4 d-flex justify-content-end">
                                <button type="button" className="btn btn-custom btn-sm" onClick={exportExcel}><BiDownload/> Download</button>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12 text-center">
                            {loadGrafico ? 'Carregando... ':null}
                            <RotatingLines
                                strokeColor="gray"
                                strokeWidth="5"
                                animationDuration="0.75"
                                width="20"
                                visible={loadGrafico}
                            />
                        </div>
                        {
                            tipoGrafico !== "funcionario" ?
                            <div className="col-sm-12">
                                <Accordion>
                                    {
                                        questoesSearch.map((grafico,key) => 
                                            <Accordion.Item eventKey={key}>
                                                <Accordion.Header><span className="fw-bold">{grafico.curso}</span></Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="row">
                                                    {
                                                        grafico.questao.map((questoes, key) => 
                                                        <div className="col-sm-6 border">
                                                            <p className="fw-bold">{questoes.descricao}</p>
                                                            <Chart
                                                            chartType="PieChart"
                                                            data={questoes.alternativas}
                                                            width={"100%"}
                                                            height={"100%"}
                                                            />
                                                        </div>
                                                        )
                                                    }
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        )
                                    }
                                </Accordion>
                            </div>
                            :
                            questoesSearch.map((grafico, key) => 
                                <div className="col-sm-6 border">
                                    <p className="fw-bold">{grafico.descricao}</p>
                                    <Chart
                                    chartType="PieChart"
                                    data={grafico.alternativas}
                                    width={"100%"}
                                    height={"400px"}
                                    />
                                </div>
                                )
                            }
                    </div>
                </Modal.Body>
            </Modal>

        </div>
    )
}